import Head from 'next/head';
import { Box, Container, Typography } from '@mui/material';
import { DashboardLayout } from '../dashboard-layout';

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import ItemCard from './ItemCard';
import { useParams } from 'react-router-dom';

const db = app.firestore();

const AddItem = () => {
  const { id } = useParams();

  return (
    <>
      <Head>
        <title>
          Ajouter produit
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth="md">
          <Typography
            sx={{ mb: 3 }}
            variant="h4"
          >
            Ajouter un nouveau produit
          </Typography>
          <ItemCard itemId={id} isUpdate={false}/>
        </Container>
      </Box>
    </>
  )
};

AddItem.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default AddItem;
